import { useAtom } from "jotai";
import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import BarreAcces from "../../../common/CarteLead/BarreAcces";
import "../../../common/CarteLead/carteLead.scss";
import usePanneauCarte from "../../../common/CarteLead/usePanneauCarte";
import ZoneCommentaires from "../../../common/CarteLead/ZoneCommentaires";
import ZoneTaches from "../../../common/CarteLead/ZoneTaches";
import useStatus from "../../LeadListPage/LeadList/LeadItem/LeadStatus/useStatus";
import EnTeteLead, { nomDuLead } from "./carte/EnTeteLead";
import { extrasBarre } from "./carte/extrasOnglets";
import { agentTimelineAtom } from "./LeadAutoAgent/agentTimelineAtom";
import ZoneContact from "./carte/ZoneContact";
import ZoneDevis from "./carte/ZoneDevis";
import { LeadAutoItemContext } from "./LeadAutoItemContext";
import { ONGLETS } from "./panneau/ongletsLeadAuto";
import PanneauLeadAuto from "./panneau/PanneauLeadAuto";
import useLeadAutoItem from "./useLeadAutoItem";

const queryString = require("query-string");

// Carte d'un lead auto (PER-2448, maquette docs/maquettes/leads-auto-refonte.html),
// construite avec le kit commun (components/common/CarteLead) : en-tête
// (identité et actions), quatre zones (contact, commentaires, tâches, devis)
// et la barre d'accès aux sections, qui s'ouvrent dans le panneau de détail à
// droite de la liste. La couleur du statut borde la carte et remplit la tuile
// du produit (PER-2447).
const LeadAutoItem = ({ data, myRole }) => {
  const { actions, leadAutoItem } = useLeadAutoItem();
  const { panneau, contacts, tasksByProduct } = useContext(LeadAutoItemContext);
  const { statusRef } = useStatus(leadAutoItem?.status);
  const location = useLocation();
  const panneauCarte = usePanneauCarte(panneau, leadAutoItem?.id);
  // Dernière timeline de l'agent chargée dans le panneau : la pastille « Agent » dit « 2 compagnies » s'il y a lieu (PER-2500).
  const [agentTimeline] = useAtom(agentTimelineAtom);
  const { estOuvert } = panneauCarte;

  const canIUploadQuotation = ["ADMIN", "MANAGER", "COLLABORATOR"].includes(myRole);

  useEffect(() => {
    actions.initItem(data);
  }, [data, actions]);

  // Lien profond d'une notification (?leadId=…) : la carte vient à l'écran.
  useEffect(() => {
    const parsed = queryString.parse(location.search, { arrayFormat: "bracket" });
    let tm = null;
    if (leadAutoItem?.id && parsed.leadId === leadAutoItem.id) {
      tm = setTimeout(() => {
        const el = document.querySelector(`#leadautoitem${leadAutoItem.id}`);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 1000);
    }
    return () => clearTimeout(tm);
  }, [leadAutoItem?.id, location.search]);

  // La carte du lead ouvert dans le panneau reste visible dans la liste.
  useEffect(() => {
    if (!estOuvert || !leadAutoItem?.id) return;
    const el = document.querySelector(`#leadautoitem${leadAutoItem.id}`);
    if (!el) return;
    const r = el.getBoundingClientRect();
    if (r.top < 72 || r.bottom > window.innerHeight) el.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }, [estOuvert, leadAutoItem?.id]);

  if (!leadAutoItem.id) return null;

  const ton = statusRef?.color || "primary";

  return (
    <article
      className={`la la-carte la-ton-${ton} ${estOuvert ? "la-carte--ouverte" : ""}`.trim()}
      id={`leadautoitem${leadAutoItem.id}`}
      aria-labelledby={`la-nom-${leadAutoItem.id}`}
    >
      <EnTeteLead />
      <div className="la-carte__corps">
        <ZoneContact ouvrir={panneauCarte.ouvrir} />
        <ZoneCommentaires
          commentaires={leadAutoItem.comments || []}
          contacts={contacts}
          onAjouter={actions.onAddComment}
          ouvrir={panneauCarte.ouvrir}
        />
        <ZoneTaches
          taches={leadAutoItem.tasks || []}
          catalogue={tasksByProduct}
          onBasculer={actions.onUpdateTask}
          ouvrir={panneauCarte.ouvrir}
        />
        <ZoneDevis canUpload={canIUploadQuotation} />
      </div>
      <BarreAcces onglets={ONGLETS} extra={extrasBarre(leadAutoItem, agentTimeline)} nom={nomDuLead(leadAutoItem)} panneauCarte={panneauCarte} />
      {estOuvert && <PanneauLeadAuto canCommand={canIUploadQuotation} ton={ton} />}
    </article>
  );
};

export default LeadAutoItem;
